import PrintResponses from './PrintResponses';

export default PrintResponses;
